define('SuiteCommerce.OrderStatus.Instrumentation.FallbackLogger', ['Url', 'jQuery'], function define(Url, $) {
	'use strict';
	var instance = null;
	var environment = null;
	function FallbackLogger() {
		var queueErrorTemp = [];
		var queueInfoTemp = [];
		var QUEUE_NAME_SUFFIX = '-OrderStatus';
		var QUEUE_ERROR_NAME = 'queueError' + QUEUE_NAME_SUFFIX;
		var QUEUE_INFO_NAME = 'queueInfo' + QUEUE_NAME_SUFFIX;
		var isWaiting = false;
		var self = this;
		if (this instanceof FallbackLogger) {
			throw new Error('Is not possible to create a new Logger. Please use getLogger method instead.');
		}
		this.isEnabled = function isEnabled() {
			return environment && !environment.isPageGenerator();
		};
		function clearQueues() {
			localStorage.setItem(QUEUE_ERROR_NAME, JSON.stringify(queueErrorTemp));
			localStorage.setItem(QUEUE_INFO_NAME, JSON.stringify(queueInfoTemp));
			queueErrorTemp.length = 0;
			queueInfoTemp.length = 0;
			isWaiting = false;
		}
		function appendTemp() {
			var queueError = localStorage.getItem(QUEUE_ERROR_NAME);
			var queueInfo = localStorage.getItem(QUEUE_INFO_NAME);
			if (queueErrorTemp.length > 0) {
				queueError = queueError == null ? [] : JSON.parse(queueError);
				localStorage.setItem(QUEUE_ERROR_NAME, JSON.stringify(queueError.concat(queueErrorTemp)));
			}
			if (queueInfoTemp.length > 0) {
				queueInfo = queueInfo == null ? [] : JSON.parse(queueInfo);
				localStorage.setItem(QUEUE_INFO_NAME, JSON.stringify(queueInfo.concat(queueInfoTemp)));
			}
			isWaiting = false;
		}
		function sendDataThroughUserAgent(url, data) {
			var successfullyTransfer = navigator.sendBeacon(url, JSON.stringify(data));
			if (successfullyTransfer) clearQueues();
			else appendTemp();
		}
		function sendDataThroughAjaxRequest(url, data, isAsync) {
			$.ajax({
				type: 'POST',
				url: url,
				data: JSON.stringify(data),
				async: isAsync,
			})
				.success(clearQueues)
				.fail(appendTemp);
		}
		// eslint-disable-next-line complexity
		function processQueues(isAsync) {
			if (!self.isEnabled()) {
				return;
			}
			var data;
			var parsedURL = new Url().parse(SC.ENVIRONMENT.baseUrl);
			var product = SC.ENVIRONMENT.BuildTimeInf.product;
			var URL =
				parsedURL.schema +
				'://' +
				parsedURL.netLoc +
				'/app/site/hosting/scriptlet.nl?script=customscript_' +
				product.toLowerCase() +
				'_loggerendpoint&deploy=customdeploy_' +
				product.toLowerCase() +
				'_loggerendpoint';
			var queueError = JSON.parse(localStorage.getItem(QUEUE_ERROR_NAME));
			var queueInfo = JSON.parse(localStorage.getItem(QUEUE_INFO_NAME));
			if ((queueInfo && queueInfo.length > 0) || (queueError && queueError.length > 0)) {
				isWaiting = true;
				data = { type: product, info: queueInfo, error: queueError };
				if (navigator.sendBeacon) {
					sendDataThroughUserAgent(URL, data);
				} else {
					sendDataThroughAjaxRequest(URL, data, isAsync);
				}
			}
		}
		this.info = function info(obj) {
			var objWrapper = obj;
			var queueInfo;
			if (!this.isEnabled()) {
				return;
			}
			objWrapper.suiteScriptAppVersion = SC.ENVIRONMENT.RELEASE_METADATA.version;
			objWrapper.message = 'clientSideLogDateTime: ' + new Date().toISOString();
			if (isWaiting) {
				queueInfoTemp.push(objWrapper);
			} else {
				queueInfo = JSON.parse(localStorage.getItem(QUEUE_INFO_NAME)) || [];
				queueInfo.push(objWrapper);
				localStorage.setItem(QUEUE_INFO_NAME, JSON.stringify(queueInfo));
			}
		};
		this.error = function error(obj) {
			var queueError;
			var objWrapper = obj;
			if (!this.isEnabled()) {
				return;
			}
			objWrapper.suiteScriptAppVersion = SC.ENVIRONMENT.RELEASE_METADATA.version;
			objWrapper.message = 'clientSideLogDateTime: ' + new Date().toISOString();
			if (isWaiting) {
				queueErrorTemp.push(objWrapper);
			} else {
				queueError = JSON.parse(localStorage.getItem(QUEUE_ERROR_NAME)) || [];
				queueError.push(objWrapper);
				localStorage.setItem(QUEUE_ERROR_NAME, JSON.stringify(queueError));
			}
		};
		if (!this.isEnabled()) {
			return this;
		}
		setInterval(function setInterval() {
			processQueues(true);
		}, 60000);
		window.addEventListener('beforeunload', function addListener() {
			processQueues(false);
		});
		return this;
	}
	FallbackLogger.getLogger = function getLogger(localEnvironment) {
		environment = localEnvironment;
		instance = instance || FallbackLogger.apply({});
		return instance;
	};
	return FallbackLogger;
});
